import {Tag, TagByIdFunction} from '@web-libs/core/tags/api/tags.types';

export const AllTenantsTag: Tag = {
    value: 'tenants',
};

export const tenantTag: Tag = {
    value: 'tenants',
    appendTenantId: true
};

export const getTenantTag: TagByIdFunction = (id: string): Tag => {
    return {
        value: 'tenants',
        id: id,
    };
};
